import React, { useState, useEffect, useCallback } from 'react';
import axios from 'axios';

export const useProjectManagement = (user, fetchProjects, externalUsers) => {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchUsers = useCallback(async () => {
    if (user?.type !== 'admin' || externalUsers) return;
    setLoading(true);
    try {
      const res = await axios.get('/api/users');
      setUsers(res.data);
    } catch (err) {
      console.error('Error fetching users:', err);
    } finally {
      setLoading(false);
    }
  }, [user?.type, externalUsers]);

  useEffect(() => {
    if (externalUsers) {
      setUsers(externalUsers);
    } else {
      fetchUsers();
    }
  }, [fetchUsers, externalUsers]);

  const createProject = async (formData) => {
    try {
      await axios.post('/api/projects', formData);
      fetchProjects();
      alert('Company created successfully');
      return true;
    } catch (err) {
      alert(err.response?.data?.msg || 'Error creating company');
      return false;
    }
  };

  const assignMember = async (memberData) => {
    const { projectId, userId, role } = memberData;
    if (!projectId || !userId) {
      alert('Select company and user');
      return false;
    }
    try {
      await axios.post(`/api/projects/${projectId}/members`, { userId, role });
      fetchProjects();
      alert('Member assigned successfully');
      return true;
    } catch (err) {
      alert(err.response?.data?.msg || 'Error assigning member');
      return false;
    }
  };

  return {
    users,
    loading,
    createProject,
    assignMember
  };
};
